<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
        <c-table
          ref="table"
          :title="title"
          tableId="table"
          :columnSetting="false"
          :isFullScreen="false"
          :columns="grid.columns"
          :data="grid.data"
          gridHeight="780px"
          @rowClick="rowClick"
          :isExcelDown="false"
        >
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
        <q-form ref="editForm">
          <c-card title="결함 상세" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline >
                <c-btn v-if="editable" label="LBLREG" icon="add" @btnClicked="addNotice" />
                <c-btn
                  v-if="editable && deleteable && dataeditable"
                  :url="deleteUrl"
                  :isSubmit="true"
                  :param="data"
                  mappingType="DELETE"
                  label="LBLREMOVE"
                  icon="remove"
                  @beforeAction="deleteNotice"
                  @btnCallback="deleteCallback" />
                <c-btn
                  v-if="editable && saveable && dataeditable"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="data"
                  :mappingType="saveType"
                  label="LBLSAVE"
                  icon="save"
                  @beforeAction="saveNotice"
                  @btnCallback="saveCallback" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-6">
                <c-text
                  :editable="editable && dataeditable"
                  :required="true"
                  label="LBLTITLE"
                  name="defectTitle"
                  v-model="data.defectTitle">
                </c-text>
              </div>
              <div class="col-3">
                <c-select
                  :editable="editable && dataeditable"
                  codeGroupCd="SYS_DEFECT_CD"
                  type="edit"
                  :required="true"
                  itemText="codeName"
                  itemValue="code"
                  name="sysDefectCd"
                  label="결함유형"
                  v-model="data.sysDefectCd"
                ></c-select>
              </div>
              <div class="col-3">
                <c-select
                  :editable="isdefectStatusCd"
                  codeGroupCd="DEFECT_STATUS_CD"
                  type="edit"
                  :required="true"
                  itemText="codeName"
                  itemValue="code"
                  name="defectStatusCd"
                  label="처리상태"
                  v-model="data.defectStatusCd"
                ></c-select>
              </div>
              <div class="col-12">
                <c-textarea
                  :editable="editable && dataeditable"
                  type="editor"
                  label="내용"
                  name="defectContents"
                  :editheight="26"
                  v-model="data.defectContents">
                </c-textarea>
              </div>
            </template>
          </c-card>
          <c-card title="개발자 답변" class="cardClassDetailForm" style="margin-top:5px !important">
            <template slot="card-detail">
              <div class="col-12">
                <c-textarea
                  :editable="isAdmin"
                  label="답변내용"
                  :rows="4"
                  name="defectAnswer"
                  v-model="data.defectAnswer">
                </c-textarea>
              </div>
            </template>
          </c-card>
        </q-form>
      </div>
    </div>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'defect-manage',
  data() {
    return {
      searchParam: {
        useFlag: 'Y',
      },
      grid: {
        columns: [
          {
            name: 'sysDefectName',
            field: 'sysDefectName',
            label: '결함유형',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'defectTitle',
            field: 'defectTitle',
            label: 'LBLTITLE',
            align: 'left',
            sortable: true,
          },
          {
            name: 'defectStatusName',
            field: 'defectStatusName',
            label: '결함상태',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'regUserName',
            field: 'regUserName',
            label: '등록자',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            name: 'regDtStr',
            field: 'regDtStr',
            label: '등록일시',
            align: 'center',
            style: 'width:130px',
            sortable: true,
          },
        ],
        data: [],
      },
      data: {
        sysDefectId: '',  // 결함번호
        sysMenuId: '',  // 메뉴 SEQ
        sysDefectCd: null,  // 결함유형
        defectTitle: '',  // 제목
        defectContents: '',  // 내용
        defectStatusCd: null,  // 결함상태
        defectAnswer: '',  // 답변
        regUserId: '',  // 등록자
        regDt: '',  // 등록일시
      },
      title: '결함 목록',
      listUrl: '',
      detailUrl: '',
      insertUrl: '',
      updateUrl: '',
      deleteUrl: '',
      isdefectStatusCd: false,
      saveable: false,
      deleteable: false,
      dataeditable: false,
      editable: true,
      updateMode: false,
      isSave: false,
      isAdmin: false,
      saveUrl: transactionConfig.sys.defect.insert.url,
      saveType: 'POST',
      searchUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = true;
      this.dataeditable = false;
      // api scope
      this.listUrl = selectConfig.sys.defect.list.url;
      this.detailUrl = selectConfig.sys.defect.get.url;
      this.insertUrl = transactionConfig.sys.defect.insert.url;
      this.updateUrl = transactionConfig.sys.defect.update.url;
      this.deleteUrl = transactionConfig.sys.defect.delete.url;

      this.getList();
    },
    rowRemoveSelect() {
      var _table = document.getElementsByClassName('bg-light-blue-1')[0];
      if (_table) {
        _table.classList.remove('bg-light-blue-1');
      }
    },
    getNoticeList() {
      this.getList();
      this.rowRemoveSelect();
      this.reset();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {sysMenuId: this.$route.query.sysMenuId};
      this.$http.request((_result) => {
        if (_result.data.length > 0) {
          this.title = '결함 목록 [' + _result.data[0].menuNm + ']';
        }
        this.grid.data = _result.data;
      },);
      this.saveable = false;
      this.deleteable = false;
    },
    rowClick(row) {
      // 상세조회
      this.saveable = true;
      this.deleteable = true;
      this.updateMode = true;
      this.$http.url = this.detailUrl;
      this.$http.param = {sysDefectId: row.sysDefectId}
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.data = _result.data;
        if (_result.data.defectStatusCd === 'DSC9999999') { // 처리완료
          this.dataeditable = false;
          this.isdefectStatusCd = false;
          this.isdefectStatusCd = false;
        } else {
          if (this.$store.getters.user.userId === _result.data.regUserId) {
            this.saveUrl = this.updateUrl;
            this.saveType = 'PUT';
            this.dataeditable = true;
            if (this.$store.getters.user.userId === 'U000000001') {
              this.isdefectStatusCd = true;
              this.isAdmin = true;
            } else {
              this.isdefectStatusCd = false;
              this.isAdmin = false;
            }
          } else {
            if (this.$store.getters.user.userId === 'U000000001') {
              this.saveUrl = this.updateUrl;
              this.saveType = 'PUT';
              this.dataeditable = true;
              this.isdefectStatusCd = true;
              this.isAdmin = true;
            } else {
              this.dataeditable = false;
              this.isdefectStatusCd = false;
              this.isdefectStatusCd = false;
            }
          }
        }
      },
      () => {
      });
    },
    addNotice() {
      this.saveable = true;
      this.deleteable = false;
      this.saveUrl = this.insertUrl;
      this.saveType = 'POST';
      this.updateMode = false;
      this.dataeditable = true;
      this.data = {
        sysDefectId: '',  // 결함번호
        sysMenuId: this.$route.query.sysMenuId,  // 메뉴 SEQ
        sysDefectCd: null,  // 결함유형
        defectTitle: '',  // 제목
        defectContents: '',  // 내용
        defectStatusCd: 'DSC0000001',  // 결함상태
        defectAnswer: '',  // 답변
        regUserId: '',  // 등록자
      };
      this.rowRemoveSelect();
    },
    reset() {
      this.rowRemoveSelect();
      this.saveable = false;
      this.deleteable = false;
      this.updateMode = false;
      this.dataeditable = false;
      this.data = {
        sysDefectId: '',  // 결함번호
        sysMenuId: this.$route.query.sysMenuId,  // 메뉴 SEQ
        sysDefectCd: null,  // 결함유형
        defectTitle: '',  // 제목
        defectContents: '',  // 내용
        defectStatusCd: null,  // 결함상태
        defectAnswer: '',  // 답변
        regUserId: '',  // 등록자
      };
    },
    saveNotice() {
      this.$refs['editForm'].validate().then(_result => {
        // 중복체크
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',
            message: 'MSGSAVE', // 저장하시겠습니까?
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.data.regUserId = this.$store.getters.user.userId;
              this.data.chgUserId = this.$store.getters.user.userId;
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    deleteNotice() {
      window.getApp.$emit('CONFIRM', {
        title: 'LBLCONFIRM',
        message: 'MSGREMOVE', // 삭제하시겠습니까?,
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.data.sysDefectId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            this.isSave = !this.isSave;
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      if (this.saveType == 'PUT') {
        this.getList();
        this.rowClick({ sysDefectId: result.data.sysDefectId })
      } else {
        this.getNoticeList();
      }
    },
    deleteCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getNoticeList();
    },
  }
};
</script>
